import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { ResumeAchievementSchema } from "../../../validation/validator";
import Form from "react-bootstrap/Form";
import { RootState } from "../../../store/store";
import { setResumeDetails } from "../../../store/resume.store";
import { useCustomNavigate } from "../../../hooks/useCustomNavigate";

import { TagsInput } from "react-tag-input-component";
import { AppRoute } from "../../../router/routerConstants";

const AddAchievementModal = ({ show, onClose, isEdit }: any) => {
  const dispatch = useDispatch();

  const { resumeDetails } = useSelector(
    (state: RootState) => state.resumeSlice
  );
  const { user } = useSelector((state: RootState) => state.authSlice);
  const [NavigateTo] = useCustomNavigate();

  const [achievement, setAchievement] = useState({ achievements: [] });

  useEffect(() => {
    if (resumeDetails?.achievements) {
      setAchievement({ achievements: resumeDetails?.achievements });
    }
  }, [resumeDetails, isEdit]);

  const handleSubmit = (values: any) => {
    // console.log("Submitted Achievements:", values.achievements);
    const updatedDetails = {
      ...resumeDetails,
      achievements: values.achievements,
    };
    dispatch(setResumeDetails(updatedDetails));
    onClose();
    if (user && user?.role === "jobseeker") {
      NavigateTo(AppRoute.JOBSEEKER_AFTER_ADDED_ACHIEVEMENTS);
    } else if (user && user?.role === "localagents") {
      NavigateTo(AppRoute.AGENT_AFTER_ADDED_ACHIEVEMENTS);
    }
  };

  return (
    <Modal
      show={show}
      onHide={onClose}
      animation={false}
      aria-labelledby="contained-modal-title-vcenter"
      className="editPersonalInformation"
      centered
    >
      <button
        type="button"
        className="btn-close custom-close-btn"
        onClick={onClose}
        aria-label="Close"
        style={{
          position: "absolute",
          top: "20px",
          right: "20px",
          zIndex: 9,

          border: "none",
          fontSize: "1rem",
          cursor: "pointer",
        }}
      ></button>
      <Modal.Body>
        <div className="findbody">
          <h3>{isEdit ? "Edit" : "Add"} Achievements</h3>
          <Formik
            initialValues={achievement}
            validationSchema={ResumeAchievementSchema}
            onSubmit={handleSubmit}
          >
            {({
              setFieldValue,
              values,
              errors,
              touched,
              handleBlur,
              handleSubmit,
            }) => (
              <Form className="modalSearch" onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Your Achievements{" "}
                    <span className="text-danger">
                      ( Press Enter after entering a value. )
                    </span>
                  </Form.Label>
                  <TagsInput
                    value={values.achievements}
                    onChange={(newTags) =>
                      setFieldValue("achievements", newTags)
                    }
                    onBlur={handleBlur}
                    name="achievements"
                    placeHolder="Enter achievements"
                  />
                  {touched.achievements && errors.achievements && (
                    <div className="text-danger mt-2">
                      {errors.achievements}
                    </div>
                  )}
                </Form.Group>

                {/* <ReactTags
                  tags={values.achievements}
                  separators={[SEPARATORS.ENTER, SEPARATORS.COMMA]}
                  handleDelete={handleDelete}
                  handleAddition={handleAddition}
                  handleDrag={handleDrag}
                  handleTagClick={handleTagClick}
                  // onTagUpdate={onTagUpdate}
                  inputFieldPosition="bottom"
                  editable
                  clearAll
                  onClearAll={onClearAll}
                  maxTags={7}
                /> */}

                {/* <div className="multitypebox">
              <span>
                Passed the Licensure Examination for Teachers in 2011{" "}
                <IoClose />
              </span>
              <span>
                Bulacan District 2 Information Communication Technology
                Coordinator <IoClose />
              </span>
              <p>
                School's Information and Communication Technology
                Coordinatorship
              </p>
            </div> */}

                <div className="d-flex gp-10">
                  <Button className="btn w-100" type="submit">
                    {isEdit ? "Update" : "Save"}
                  </Button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AddAchievementModal;
